/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react-hooks/exhaustive-deps */
import Stack from '@mui/material/Stack'
import Grid, { GridProps } from '@mui/material/Grid'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import useTheme from '@mui/material/styles/useTheme'
import { ContainerProps } from '@mui/material/Container'
import Skeleton from '@mui/material/Skeleton'
import MUILink from '@mui/material/Link'
import { BreadcrumbsProps } from '@mui/material/Breadcrumbs'

import { useRouter } from 'next/router'
import { useEffect, useMemo, useState } from 'react'
import { FindListRQ, FindResultVM, ResultFilterItemModel, ResultFilterModel } from '../../../client/swaggerClient'
import { useBackend } from '../../../utils/contexts/BackendContext'
import { RenderComponentProps } from '../../RBPartnerPortal/_common/PartnerPortalComponentRender'
import FindFilterbadge from './FindFilterBadge'
import FindFilterBlock from './FindFilterBlock'
import FindItem from './FindItem'
import Link from 'next/link'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import dynamic from 'next/dynamic'
import { useLayoutData } from '../../../utils/contexts/LayoutContext'
import { colorSetter } from '../../RBPartnerPortal/PartnerPortalLayout'
import {
  FindButtonProps,
  FindDropdownMenuItemProps,
  FindDropdownMenuProps,
  FindHeaderTitleProps,
  FindTitleProps
} from './FindDesignTypes'
import FindFilterMobileBlock from './FindFilterMobileBlock'
import { SeoTextKind, useUI } from '../../../utils/contexts/UIContext/UIContext'
import { PageType } from '../../../pages/_app'
import LoadingComponent from '../../../design/common/LoadingComponent/LoadingComponent'
import FindHeadlinks from './FindHeadlinks'
import { getCategoryBannerData } from '../../../utils/functions/categoryBannerData'
import useSessionStorage from '../../../hooks/useSessionStorage'
import { useTranslation } from 'next-i18next'
import { useGTM } from '../GoogleTagManager'
import ResponsiveAdBanner from '../ResponsiveAdBanner/ResponsiveAdBanner'

export type FilterUrl = (filters: ResultFilterModel, item?: ResultFilterItemModel, url?: string, pageUrl?: string, mmbr?: string | string[]) => string

export interface FindComponentProps extends RenderComponentProps {
  baseFindUrl?: string
}

export interface FindComponentTypeProps {
  bazarItems?: FindResultVM
}
export const filterUrl: FilterUrl = (filters: ResultFilterModel, item?: ResultFilterItemModel, url?: string, pageUrl?: string, mmbr?: string | string[]) => { return (pageUrl && (pageUrl !== "/" ? pageUrl : '') + (item ? (item.selected ? filters.resetUrl ? filters.resetUrl : item.targetUrl : item.targetUrl) : url) + (mmbr ? item && !item.targetUrl?.includes('?') ? `?mmbr=${mmbr}` : `&mmbr=${mmbr}` : '')) as string }

const Find = ({ data, pageUrl }: FindComponentProps) => {
  const router = useRouter()
  const theme = useTheme()
  const { page, mmbr } = router.query
  const backend = useBackend()
  const ui = useUI()
  const { partnerSiteFull, templatePath, setTemplatePath } = useLayoutData()
  const { t } = useTranslation()
  const { sendPageViewParams, sendEvent } = useGTM()

  const [bazarItems, setBazarItems] = useState<FindResultVM | null | undefined>(null)
  const [sortOrderAnchor, setSortOrderAnchor] = useState<HTMLElement | null | undefined>(null)
  const [mainColor, setMainColor] = useState<string>(theme.palette.primary.main)
  const [secondaryColor, setSecondaryColor] = useState<string>(theme.palette.common.black)
  const sortOrderOpen = Boolean(sortOrderAnchor)
  const [skipResultItems, setSkipResultItems] = useState<boolean | null>(null)
  const [isLoading, setLoading] = useState<boolean>(false)
  const [isNavigation, setNavigation] = useState<boolean>(false)
  const [navigationTimeout, setNavigationTimeout] = useState<NodeJS.Timeout | null>(null)
  const [scrollTimeout, setScrollTimeout] = useState<NodeJS.Timeout | null>(null)
  const [listingScrollPosition, setListingScrollPosition] = useSessionStorage<number>('listingScrollPosition', 0)
  const [mmbrId, setMmbrId] = useState<string | string[] | undefined | null>(mmbr)

  const type = templatePath

  const findData = data ? data.componentData_Find : undefined
  const findUrl =
    (type !== PageType.RBhuPP ? '/' : router.asPath === pageUrl ? '/' : '') + router.asPath.replace(pageUrl as string, '')
  const clearFindUrl = findUrl.includes('?mmbr=')
    ? findUrl.substring(0, findUrl.indexOf('?mmbr='))
    : findUrl.includes('&mmbr=')
      ? findUrl.substring(0, findUrl.indexOf('&mmbr='))
      : findUrl
  const isShow = type === PageType.RBhuPP ? (data && data.enabled ? true : false) : true
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const hasItems = bazarItems?.items && bazarItems.items.length > 0
  const hasKiemeltItems = bazarItems?.itemsKiemelt && bazarItems.itemsKiemelt.length > 0

  const hasPrevUrl = Boolean(bazarItems?.paging?.prevPageUrl)
  const hasNextUrl = Boolean(bazarItems?.paging?.nextPageUrl)
  const prevUrl = bazarItems?.paging?.prevPageUrl
    ? (type === PageType.RBhuPP ? pageUrl : '') +
    bazarItems?.paging?.prevPageUrl +
    (mmbrId
      ? bazarItems?.paging?.prevPageUrl.includes('?')
        ? `&mmbr=${mmbrId}`
        : `?mmbr=${mmbrId}`
      : '')
    : '#'
  const nextUrl = bazarItems?.paging?.nextPageUrl
    ? (type === PageType.RBhuPP ? pageUrl : '') +
    bazarItems?.paging?.nextPageUrl +
    (mmbrId
      ? bazarItems?.paging?.nextPageUrl.includes('?')
        ? `&mmbr=${mmbrId}`
        : `?mmbr=${mmbrId}`
      : '')
    : '#'

  const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath

  const setColors = () => {
    setMainColor(prevMainColor => {
      return colorSetter(partnerSiteFull, 'mainColor') ?? prevMainColor
    })
    setSecondaryColor(prevSecondaryColor => {
      return colorSetter(partnerSiteFull, 'secondaryColor') ?? prevSecondaryColor
    })
  }

  const handleTemplatePath = () => {
    switch (type) {
      case PageType.RBhu:
        setTemplatePath(PageType.RBhu)
        break
      case PageType.RBhuPP:
        setTemplatePath(PageType.RBhuPP)
        break
      case PageType.SZP:
        setTemplatePath(PageType.SZP)
        break
      case PageType.SZPPL:
        setTemplatePath(PageType.SZPPL)
        break
      default:
        setTemplatePath(PageType.RBhu)
        break
    }
  }

  const getFindList = () => {
    setLoading(true)
    backend.api
      .adFindList({
        findUrl: clearFindUrl,
        defaultFilters: {
          memberFilter: type === PageType.RBhuPP && findData ? findData.defaultFilters?.memberFilter : mmbrId ? mmbrId : undefined,
          subsiteFilter: type === PageType.RBhuPP && findData ? findData.defaultFilters?.subsiteFilter : undefined,
          groupSubjectFilter: type === PageType.RBhuPP && findData ? findData.defaultFilters?.groupSubjectFilter : undefined,
          carMakeFilter: type === PageType.RBhuPP && findData ? findData.defaultFilters?.carMakeFilter : undefined,
          gumiFelniKindFilter: type === PageType.RBhuPP && findData ? findData.defaultFilters?.gumiFelniKindFilter : undefined
        },
        skipResultItems,
      } as FindListRQ)
      .then(res => {
        if (res.redirectTo) {
          router.push(res.redirectTo)
          return null;
        }

        setBazarItems(res.result)
        setLoading(false)
        if (isNavigation) {
          if (navigationTimeout) clearTimeout(navigationTimeout)
          setNavigationTimeout(setTimeout(() => window.scrollTo(0, 0), 100))
          setNavigation(false)
        }

        if (listingScrollPosition && listingScrollPosition !== 0) {
          if (scrollTimeout) clearTimeout(scrollTimeout)
          setScrollTimeout(setTimeout(() => window.scrollTo(0, listingScrollPosition as number), 100))
          setListingScrollPosition(null)
        }

        if (res.gaPageViewModel) {
          sendPageViewParams(res.gaPageViewModel)
        }

        if (res.gaEvents) {
          res.gaEvents.forEach((event) => {
            sendEvent(event)
          })
        }
      })
      .catch(err => {
        ui.errorDisplay(err)
        setLoading(false)
        setNavigation(false)
      })
  }

  useEffect(() => {
    if (type === PageType.RBhuPP && pageUrl?.replace('/', '') !== page?.[0]) return;
    if (type === PageType.RBhuPP) getFindList()
    if (type !== PageType.RBhuPP && !['/SZP', '/RBhu'].some(word => clearFindUrl.startsWith(word))) getFindList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearFindUrl])

  useEffect(() => {
    if (skipResultItems === null) return;
    if (skipResultItems === false) {
      getFindList()
      setSkipResultItems(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skipResultItems])


  useEffect(() => {
    handleTemplatePath()
    if (type !== PageType.RBhuPP || partnerSiteFull === undefined) return
    setColors()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, bazarItems, partnerSiteFull, templatePath])

  useEffect(() => {
    if (router.isReady && !mmbr) {
      const query = new URLSearchParams(window.location.search);
      if (query.has('mmbr')) setMmbrId(query.get('mmbr'))
    }
  })


  const handleSortOrderOpen = (e: React.MouseEvent<HTMLButtonElement>) => setSortOrderAnchor(e.currentTarget)
  const handleSortOrderClose = () => setSortOrderAnchor(undefined)

  const FindContainer = useMemo(
    () =>
      dynamic<ContainerProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindContainer)
      ),
    [path]
  )

  const FindHeaderGridContainer = useMemo(
    () =>
      dynamic<GridProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindHeaderGridContainer)
      ),
    [path]
  )
  const FindHeaderTitle = useMemo(
    () =>
      dynamic<FindHeaderTitleProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindHeaderTitle)
      ),
    [path]
  )
  const FindButton = useMemo(
    () =>
      dynamic<FindButtonProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindButton)
      ),
    [path]
  )
  const FindDropdownMenu = useMemo(
    () =>
      dynamic<FindDropdownMenuProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindDropdownMenu)
      ),
    [path]
  )
  const FindDropdownMenuItem = useMemo(
    () =>
      dynamic<FindDropdownMenuItemProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindDropdownMenuItem)
      ),
    [path]
  )

  const FindTitle = useMemo(
    () =>
      dynamic<FindTitleProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then((style) => style.FindTitle)
      ),
    [path]
  )

  const FindBreadcrumbs = useMemo(
    () =>
      dynamic<BreadcrumbsProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then((style) => style.FindBreadcrumbs)
      ),
    [path]
  )

  useEffect(() => {
    if (bazarItems?.pageModel?.htmlTitle) ui.seoTextsSetter(SeoTextKind.HtmlTitle, bazarItems.pageModel.htmlTitle)
    if (bazarItems?.pageModel?.htmlDesc) ui.seoTextsSetter(SeoTextKind.HtmlDescription, bazarItems.pageModel.htmlDesc)
    if (bazarItems?.pageModel?.canonicalUrl) ui.seoTextsSetter(SeoTextKind.CanonicalUrl, bazarItems.pageModel.canonicalUrl)
  }, [bazarItems?.pageModel])

  return (
    <>
      {!bazarItems ? (
        <Stack sx={{ minHeight: "100vh" }}>
          <FindContainer maxWidth={false} sx={{ mt: 4 }}>
            <LoadingComponent customColor={mainColor} noElevation={type === PageType.RBhuPP} transparent={type === PageType.RBhuPP} />
          </FindContainer>
        </Stack>
      ) : isShow ? (
        <Stack sx={{ minHeight: "100vh" }}>
          <FindContainer maxWidth={false}>
            {type !== PageType.RBhuPP ? (
              <>
                <FindBreadcrumbs>
                  {isLoading ? [...Array(router.asPath.split('/').length - 1)].map((_, i) => (
                    <Typography key={i}><Skeleton width={100} height={20} variant={"rounded"} /></Typography>
                  )) : bazarItems?.breadcrumb?.items?.map((breadcrumb, i) => {
                    return breadcrumb.url ? (
                      <Link key={i} href={breadcrumb.url as string} passHref>
                        <MUILink underline="hover" variant={"body2"}>{breadcrumb.title}</MUILink>
                      </Link>
                    ) : (
                      <Typography key={i} variant={"body2"}>{breadcrumb.title}</Typography>
                    )
                  })}
                </FindBreadcrumbs>

                {type === PageType.SZP &&
                  bazarItems.categoryBanners ? bazarItems.categoryBanners.map((banner, i) => {
                    if (!getCategoryBannerData(banner)) return null
                  
                    return (
                      <Grid key={i} container mb={3}>
                        <Grid item xs={12} display={"flex"} justifyContent={"center"}>
                          <ResponsiveAdBanner
                            adUnit={getCategoryBannerData(banner)!.adUnit}
                            name={getCategoryBannerData(banner)!.name}
                            size={[[1280, 108], [600, 188], [1, 1]]}
                          />
                        </Grid>
                      </Grid>
                    )
                }) : null}
                
                <FindHeadlinks
                  title={bazarItems.pageModel?.pageTitle}
                  headlinks={bazarItems.headlinks}
                />
              </>
            ) : null}


            <Grid container>
              {!isMobile ? (
                <Grid item xs={12} md={3} pl={2}
                  pr={type !== PageType.RBhuPP ? 2 : 0}
                  pt={type !== PageType.RBhuPP ? 2 : 0}
                  height={"100%"}
                  bgcolor={
                    type !== PageType.RBhuPP ?
                      theme.palette.mode === "dark" ? theme.palette.grey[900] : theme.palette.common.white
                      : undefined
                  }
                  borderRadius={(type === PageType.SZP || type === PageType.SZPPL) ? "8px" : undefined}
                  boxShadow={(type === PageType.SZP || type === PageType.SZPPL) ? "0px 1px 3px rgba(3, 0, 71, 0.09)" : undefined}
                >
                  {bazarItems?.resultFilters?.map((filters, i) => (
                    <FindFilterBlock
                      key={filters.title ?? i}
                      filters={filters}
                      pageUrl={pageUrl}
                      colors={{
                        mainColor: mainColor,
                        secondaryColor: secondaryColor
                      }}
                    />
                  ))}
                </Grid>
              ) : null}
              <Grid item xs={12} md={9} pl={isMobile ? 0 : 3}>
                <FindHeaderGridContainer
                  container
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  px={{ xs: 1, sm: 0 }}
                  mb={1}
                  pb={1}
                >
                  <Grid item>
                    <Stack flexDirection={'row'}>
                      {type !== PageType.RBhuPP && mmbrId ? (
                        <Typography variant="h6" fontWeight={'bold'} lineHeight={1} mr={1}>
                          [{t('web.listing.hirdetoText')} #{mmbrId}]
                        </Typography>
                      ) : (
                        ''
                      )}
                      <FindHeaderTitle>
                        {type !== PageType.RBhuPP && mmbrId ?
                          t('web.listing.hirdetesText', { adCount: bazarItems?.foundCount?.toLocaleString('hu-HU') }) :
                          t('web.listing.talalatText', { adCount: bazarItems?.foundCount?.toLocaleString('hu-HU') })}
                      </FindHeaderTitle>
                    </Stack>
                  </Grid>
                  {!isMobile ? (
                    <Grid item>
                      <FindButton
                        id="dropdown-button"
                        aria-controls={sortOrderOpen ? 'dropdown-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={sortOrderOpen ? 'true' : undefined}
                        bgcolor={mainColor}
                        bghovercolor={secondaryColor}
                        dropdown={1}
                        onClick={handleSortOrderOpen}
                        variant="contained"
                        endIcon={type !== PageType.RBhuPP ? sortOrderOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon /> : undefined}
                      >
                        {bazarItems?.sortOrders?.map(item => (item.isSelected ? item.title : null))}
                      </FindButton>
                      <FindDropdownMenu
                        id="dropdown-menu"
                        anchorEl={sortOrderAnchor}
                        open={sortOrderOpen}
                        onClose={handleSortOrderClose}
                        MenuListProps={{
                          'aria-labelledby': 'dropdown-button',
                        }}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'right',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                      >
                        {bazarItems?.sortOrders?.map((item, i) => {
                          const url = (
                            (pageUrl && pageUrl !== '/' ? pageUrl + item.url : item.url) +
                            (type !== PageType.RBhuPP && mmbrId
                              ? item.url?.includes('?')
                                ? `&mmbr=${mmbrId}`
                                : `?mmbr=${mmbrId}`
                              : '')
                          ) as string

                          return (
                            <Link
                              key={i}
                              href={url}
                              scroll={false}
                            >
                              <FindDropdownMenuItem
                                selected={item.isSelected}
                                bgcolor={mainColor}
                                onClick={handleSortOrderClose}
                              >
                                {item.title}
                              </FindDropdownMenuItem>
                            </Link>
                          )
                        })}
                      </FindDropdownMenu>
                    </Grid>
                  ) : null}
                </FindHeaderGridContainer>
                <Grid container mb={2} px={{ xs: 1, sm: 0 }}>
                  <Grid item xs={12}>
                    {bazarItems?.resultFilters?.map(
                      (filters, i) =>
                        filters?.resetBadgeText && filters?.resetBadgeText !== "" ? (
                          <FindFilterbadge
                            key={i}
                            title={filters.resetBadgeText}
                            resetUrl={filters.resetUrl}
                            pageUrl={page && page[0]}
                            colors={{
                              mainColor: mainColor,
                              secondaryColor: secondaryColor,
                            }}
                          />
                        ) : null
                    )}
                  </Grid>
                </Grid>
                <Grid container justifyContent={'center'}>
                  <Grid item xs={12}>
                    {hasKiemeltItems && (type !== PageType.RBhuPP) ? (
                      <>
                        {bazarItems?.itemsKiemelt?.map((item, i) => (
                          <FindItem
                            key={i}
                            item={item}
                            colors={{
                              mainColor: mainColor,
                              secondaryColor: secondaryColor,
                            }}
                            isLoading={isLoading}
                            isKiemelt={true}
                            setFavButton={false}
                            preload={i < 2}
                          />
                        ))}
                      </>
                    ) : null}
                    {hasItems ? (
                      <>
                        {bazarItems?.items?.map((item, i) => (
                          <FindItem
                            key={i}
                            item={item}
                            colors={{
                              mainColor: mainColor,
                              secondaryColor: secondaryColor,
                            }}
                            isLoading={isLoading}
                            setFavButton={false}
                            preload={i < 2}
                          />
                        ))}

                        <Stack flexDirection={'row'} justifyContent={'end'}>
                          <Link
                            href={prevUrl}
                            passHref
                            scroll={false}
                          >
                            <a className={!hasPrevUrl ? 'disabled' : ''}>
                              <FindButton
                                disabled={!hasPrevUrl}
                                startIcon={<ChevronLeftIcon />}
                                filterbutton={1}
                                navigation={1}
                                variant="outlined"
                                bgcolor={mainColor}
                                bghovercolor={secondaryColor}
                                onClick={() => setNavigation(true)}
                              >
                                {t('web.listing.elozoButtonText')}
                              </FindButton>
                            </a>
                          </Link>
                          <Link
                            href={nextUrl}
                            passHref
                            scroll={false}
                          >
                            <a className={!hasNextUrl ? 'disabled' : ''}>
                              <FindButton
                                disabled={!hasNextUrl}
                                endIcon={<ChevronRightIcon />}
                                filterbutton={1}
                                navigation={1}
                                variant="outlined"
                                bgcolor={mainColor}
                                bghovercolor={secondaryColor}
                                onClick={() => setNavigation(true)}
                              >
                                {t('web.listing.kovetkezoButtonText')}
                              </FindButton>
                            </a>
                          </Link>
                        </Stack>
                      </>
                    ) :
                      isLoading ? (
                        <Stack alignItems={"center"}>
                          <CircularProgress sx={{ color: mainColor }} />
                        </Stack>
                      ) : (
                        <Stack textAlign={"center"}>
                          <FindTitle>
                            {t('web.listing.nincsTalalatText')}
                          </FindTitle>
                        </Stack>
                      )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </FindContainer>
          {isMobile ?
            <FindFilterMobileBlock
              isMobile={isMobile}
              bazarItems={bazarItems}
              pageUrl={pageUrl}
              mmbr={mmbrId ?? undefined}
              colors={{
                mainColor: mainColor,
                secondaryColor: secondaryColor,
              }}
              isSkipResult={skipResultItems}
              skipResult={setSkipResultItems}
            />
            : null}
        </Stack>
      ) : null}
    </>
  )
}

export default Find
